<template>
  <base-section id="financial-report" class="financial-report-section">
    <base-section-heading color="transparent" title="Laporan Keuangan" />

    <v-container>
      <div class="financial-report-shell">
        <div class="financial-report-layout">
          <div class="financial-report-nav">
            <div class="financial-tabs">
              <button
                v-for="tab in reportTabs"
                :key="tab.value"
                type="button"
                class="financial-tab"
                :class="{ 'financial-tab--active': activeTab === tab.value }"
                @click="activeTab = tab.value"
              >
                <div class="financial-tab__content">
                  <div class="financial-tab__label">
                    <v-icon small>{{ tab.icon }}</v-icon>
                    <span>{{ tab.label }}</span>
                  </div>
                  <span class="financial-tab__count">{{ tab.count }}</span>
                </div>
              </button>
            </div>
          </div>

          <div class="financial-report-content">
            <v-tabs-items
              v-model="activeTab"
              class="financial-tab-panels"
              touchless
            >
              <v-tab-item value="tahunan">
                <v-card flat class="financial-panel">
                  <div class="financial-panel__header">
                    <div>
                      <p class="financial-panel__eyebrow">Publish Koran</p>
                      <h4 class="financial-panel__title">
                        Arsip publikasi tahunan
                      </h4>
                    </div>
                    <span class="financial-panel__badge">
                      {{ report_pk.length }} dokumen
                    </span>
                  </div>

                  <div v-if="report_pk.length" class="financial-report-list">
                    <button
                      v-for="card in report_pk"
                      :key="card.web_report_name"
                      type="button"
                      class="financial-report-item"
                      @click="Open(card.web_report_path_url)"
                    >
                      <span class="financial-report-item__icon">
                        <v-icon color="#c53d36">mdi-file-pdf-box</v-icon>
                      </span>
                      <span class="financial-report-item__body">
                        <span class="financial-report-item__title">
                          {{ card.web_report_name }}
                        </span>
                        <span class="financial-report-item__meta">
                          Buka dokumen PDF di tab baru
                        </span>
                      </span>
                      <v-icon class="financial-report-item__arrow">
                        mdi-arrow-top-right
                      </v-icon>
                    </button>
                  </div>

                  <div v-else class="financial-empty-state">
                    Belum ada laporan yang tersedia pada kategori ini.
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item value="triwulan">
                <v-card flat class="financial-panel">
                  <div class="financial-panel__header">
                    <div>
                      <p class="financial-panel__eyebrow">Triwulan</p>
                      <h4 class="financial-panel__title">
                        Laporan berdasarkan tahun
                      </h4>
                    </div>
                    <span class="financial-panel__badge">
                      {{ report_tw.length }} dokumen
                    </span>
                  </div>

                  <v-list
                    v-if="yearsTriwulan.length"
                    class="financial-group-list"
                  >
                    <v-list-group
                      v-for="year in yearsTriwulan"
                      :key="year"
                      :value="year === yearsTriwulan[0]"
                      class="financial-group"
                      no-action
                    >
                      <template v-slot:activator>
                        <div class="financial-group__activator">
                          <div class="financial-group__heading">
                            <v-icon color="#355c7d">mdi-calendar-range</v-icon>
                            <span>{{ year }}</span>
                          </div>
                          <span class="financial-group__count">
                            {{ reportsByYearTriwulan[year].length }} file
                          </span>
                        </div>
                      </template>

                      <button
                        v-for="report in reportsByYearTriwulan[year]"
                        :key="report.web_report_name"
                        type="button"
                        class="financial-report-item financial-report-item--nested"
                        @click="Open(report.web_report_path_url)"
                      >
                        <span class="financial-report-item__icon">
                          <v-icon color="#c53d36">mdi-file-pdf-box</v-icon>
                        </span>
                        <span class="financial-report-item__body">
                          <span class="financial-report-item__title">
                            {{ report.web_report_name }}
                          </span>
                          <span class="financial-report-item__meta">
                            Laporan triwulan {{ year }}
                          </span>
                        </span>
                        <v-icon class="financial-report-item__arrow">
                          mdi-arrow-top-right
                        </v-icon>
                      </button>
                    </v-list-group>
                  </v-list>

                  <div v-else class="financial-empty-state">
                    Belum ada laporan yang tersedia pada kategori ini.
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item value="bulanan">
                <v-card flat class="financial-panel">
                  <div class="financial-panel__header">
                    <div>
                      <p class="financial-panel__eyebrow">Bulanan</p>
                      <h4 class="financial-panel__title">
                        Laporan berkala per tahun
                      </h4>
                    </div>
                    <span class="financial-panel__badge">
                      {{ report_bl.length }} dokumen
                    </span>
                  </div>

                  <v-list
                    v-if="yearsBulanan.length"
                    class="financial-group-list"
                  >
                    <v-list-group
                      v-for="year in yearsBulanan"
                      :key="year"
                      :value="year === yearsBulanan[0]"
                      class="financial-group"
                      no-action
                    >
                      <template v-slot:activator>
                        <div class="financial-group__activator">
                          <div class="financial-group__heading">
                            <v-icon color="#355c7d">mdi-calendar-month</v-icon>
                            <span>{{ year }}</span>
                          </div>
                          <span class="financial-group__count">
                            {{ reportsByYearBulanan[year].length }} file
                          </span>
                        </div>
                      </template>

                      <button
                        v-for="report in reportsByYearBulanan[year]"
                        :key="report.web_report_name"
                        type="button"
                        class="financial-report-item financial-report-item--nested"
                        @click="Open(report.web_report_path_url)"
                      >
                        <span class="financial-report-item__icon">
                          <v-icon color="#c53d36">mdi-file-pdf-box</v-icon>
                        </span>
                        <span class="financial-report-item__body">
                          <span class="financial-report-item__title">
                            {{ report.web_report_name }}
                          </span>
                          <span class="financial-report-item__meta">
                            Diurutkan dari publikasi terbaru
                          </span>
                        </span>
                        <v-icon class="financial-report-item__arrow">
                          mdi-arrow-top-right
                        </v-icon>
                      </button>
                    </v-list-group>
                  </v-list>

                  <div v-else class="financial-empty-state">
                    Belum ada laporan yang tersedia pada kategori ini.
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item value="keberlanjutan">
                <v-card flat class="financial-panel">
                  <div class="financial-panel__header">
                    <div>
                      <p class="financial-panel__eyebrow">Keberlanjutan</p>
                      <h4 class="financial-panel__title">
                        Dokumen sustainability report
                      </h4>
                    </div>
                    <span class="financial-panel__badge">
                      {{ report_kb.length }} dokumen
                    </span>
                  </div>

                  <div v-if="report_kb.length" class="financial-report-list">
                    <button
                      v-for="card in report_kb"
                      :key="card.web_report_name"
                      type="button"
                      class="financial-report-item"
                      @click="Open(card.web_report_path_url)"
                    >
                      <span class="financial-report-item__icon">
                        <v-icon color="#c53d36">mdi-file-pdf-box</v-icon>
                      </span>
                      <span class="financial-report-item__body">
                        <span class="financial-report-item__title">
                          {{ card.web_report_name }}
                        </span>
                        <span class="financial-report-item__meta">
                          Buka dokumen PDF di tab baru
                        </span>
                      </span>
                      <v-icon class="financial-report-item__arrow">
                        mdi-arrow-top-right
                      </v-icon>
                    </button>
                  </div>

                  <div v-else class="financial-empty-state">
                    Belum ada laporan yang tersedia pada kategori ini.
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionFinancialReport",
  data: () => ({
    activeTab: "tahunan",
    report_pk: [],
    report_tw: [],
    report_bl: [],
    report_kb: []
  }),
  created() {
    this.Report("PK");
    this.Report("TW");
    this.Report("BL");
    this.Report("KB");
  },
  computed: {
    reportTabs() {
      return [
        {
          value: "tahunan",
          label: "Publish Koran",
          icon: "mdi-newspaper-variant-outline",
          count: this.report_pk.length
        },
        {
          value: "triwulan",
          label: "Triwulan",
          icon: "mdi-chart-box-outline",
          count: this.report_tw.length
        },
        {
          value: "bulanan",
          label: "Bulanan",
          icon: "mdi-calendar-month-outline",
          count: this.report_bl.length
        },
        {
          value: "keberlanjutan",
          label: "Keberlanjutan",
          icon: "mdi-leaf-circle-outline",
          count: this.report_kb.length
        }
      ];
    },
    yearsTriwulan() {
      return [...new Set(this.report_tw.map(r => r.web_report_year))].sort(
        (a, b) => b - a
      );
    },
    reportsByYearTriwulan() {
      return this.yearsTriwulan.reduce(
        (acc, year) => ({
          ...acc,
          [year]: this.report_tw
            .filter(r => r.web_report_year === year)
            .sort((a, b) => a.web_report_name.localeCompare(b.web_report_name))
        }),
        {}
      );
    },
    yearsBulanan() {
      return [...new Set(this.report_bl.map(r => r.web_report_year))].sort(
        (a, b) => b - a
      );
    },
    reportsByYearBulanan() {
      return this.yearsBulanan.reduce(
        (acc, year) => ({
          ...acc,
          [year]: this.report_bl
            .filter(r => r.web_report_year === year)
            .sort(
              (a, b) =>
                new Date(b.web_report_cdate) - new Date(a.web_report_cdate)
            )
        }),
        {}
      );
    }
  },
  methods: {
    Report(category) {
      let formdata = {
        web_report_category: category,
        order_by: "web_report_year",
        order_type: "DESC"
      };
      let param = this.$functions.ParamPOST(formdata);
      this.$axios
        .post(this.$functions.UrlPOST("apiWebReportList"), param, {
          headers: {
            "Content-Type": "text/plain; charset=ISO-8859-1"
          }
        })
        .then(response => {
          let data = response.data;
          if (data.length > 0) {
            if (data[0].feedback === "Y") {
              if (category === "PK") {
                this.report_pk = data;
              } else if (category === "TW") {
                this.report_tw = data;
              } else if (category === "BL") {
                this.report_bl = data;
              } else if (category === "KB") {
                this.report_kb = data;
              }
            } else {
              this.snackbar.value = true;
              this.snackbar.text = data[0].feedback;
            }
          } else {
            if (category === "PK") {
              this.report_pk = [];
            } else if (category === "TW") {
              this.report_tw = [];
            } else if (category === "BL") {
              this.report_bl = [];
            } else if (category === "KB") {
              this.report_kb = [];
            }
          }
        })
        .catch(e => {
          this.snackbar.value = true;
          this.snackbar.text = e;
        });
    },
    Open(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.financial-report-section {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef3f8 100%);
}

.financial-report-shell {
  padding: 8px 0 12px;
}

.financial-report-description {
  max-width: 640px;
  margin: 0 0 20px;
  color: #5e6b7a;
  font-size: 0.98rem;
  line-height: 1.7;
}

.financial-report-layout {
  display: grid;
  grid-template-columns: minmax(260px, 300px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.financial-report-nav {
  position: sticky;
  top: 24px;
}

.financial-tabs {
  padding: 12px;
  border: 1px solid rgba(76, 104, 132, 0.12);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 16px 36px rgba(39, 58, 80, 0.08);
}

.financial-tab {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 78px;
  margin-bottom: 10px;
  padding: 0 8px;
  border: 0;
  border-radius: 18px;
  background: transparent;
  text-transform: none;
  letter-spacing: 0;
  justify-content: flex-start;
  cursor: pointer;
}

.financial-tab:last-child {
  margin-bottom: 0;
}

.financial-tab::before {
  display: none;
}

.financial-tab__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.financial-tab__label {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #33475b;
  font-size: 0.98rem;
  font-weight: 600;
}

.financial-tab__count {
  min-width: 34px;
  padding: 7px 10px;
  border-radius: 999px;
  background: #edf3f8;
  color: #4d6985;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
}

.financial-tab--active {
  background: linear-gradient(135deg, #24425d 0%, #355c7d 100%);
  box-shadow: 0 14px 28px rgba(36, 66, 93, 0.24);
}

.financial-tab--active .financial-tab__label,
.financial-tab--active .v-icon {
  color: #fff !important;
}

.financial-tab--active .financial-tab__count {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.financial-tab-panels {
  background: transparent;
}

.financial-panel {
  padding: 28px;
  border: 1px solid rgba(76, 104, 132, 0.1);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 20px 40px rgba(39, 58, 80, 0.08);
}

.financial-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
}

.financial-panel__eyebrow {
  margin: 0 0 6px;
  color: #69829b;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.financial-panel__title {
  margin: 0;
  color: #22313f;
  font-size: 1.35rem;
  font-weight: 700;
}

.financial-panel__badge {
  flex-shrink: 0;
  padding: 10px 14px;
  border-radius: 999px;
  background: #edf3f8;
  color: #4d6985;
  font-size: 0.82rem;
  font-weight: 700;
}

.financial-report-list,
.financial-group-list {
  display: grid;
  gap: 14px;
}

.financial-group-list {
  padding: 0;
  background: transparent !important;
}

.financial-group {
  border: 1px solid rgba(76, 104, 132, 0.1);
  border-radius: 22px;
  background: #f9fbfd;
  overflow: hidden;
}

.financial-group__activator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 14px;
  padding: 4px 0;
}

.financial-group__heading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #2d4356;
  font-size: 1rem;
  font-weight: 700;
}

.financial-group__count {
  color: #73879b;
  font-size: 0.82rem;
  font-weight: 700;
}

.financial-report-item {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 18px 20px;
  border: 1px solid rgba(76, 104, 132, 0.1);
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbfe 100%);
  text-align: left;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.financial-report-item:hover {
  transform: translateY(-2px);
  border-color: rgba(76, 104, 132, 0.22);
  box-shadow: 0 14px 24px rgba(39, 58, 80, 0.08);
}

.financial-report-item--nested {
  margin: 0 16px 16px;
}

.financial-report-item__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: #fdf0ef;
  flex-shrink: 0;
}

.financial-report-item__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.financial-report-item__title {
  color: #263645;
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.5;
}

.financial-report-item__meta {
  color: #73879b;
  font-size: 0.82rem;
}

.financial-report-item__arrow {
  color: #5f7a95;
  flex-shrink: 0;
}

.financial-empty-state {
  padding: 28px;
  border: 1px dashed rgba(76, 104, 132, 0.18);
  border-radius: 20px;
  color: #6d7f90;
  text-align: center;
  background: #f6f9fc;
}

::v-deep .financial-group-list .v-list-group__header {
  padding: 14px 18px;
}

::v-deep .financial-group-list .v-list-group__items .v-list-item {
  min-height: auto;
}

@media (max-width: 959px) {
  .financial-report-shell {
    padding-top: 4px;
  }

  .financial-report-description {
    margin-bottom: 16px;
  }

  .financial-report-layout {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .financial-report-nav {
    position: static;
  }

  .financial-tabs {
    padding: 10px;
    border-radius: 20px;
  }

  .financial-tab {
    min-width: 0;
    min-height: 68px;
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 10px;
    border-radius: 16px;
  }

  .financial-tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .financial-tab__content {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .financial-tab__label {
    width: 100%;
    font-size: 0.92rem;
  }

  .financial-tab__count {
    min-width: 0;
    padding: 6px 10px;
  }
}

@media (max-width: 600px) {
  .financial-report-description {
    font-size: 0.92rem;
    line-height: 1.6;
  }

  .financial-tabs {
    padding: 8px;
    border-radius: 18px;
  }

  .financial-tab {
    min-height: 58px;
    padding: 0 12px;
  }

  .financial-tabs {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .financial-tab__content {
    align-items: center;
    flex-direction: row;
    gap: 10px;
  }

  .financial-tab__label {
    flex: 1;
    align-items: center;
    font-size: 0.9rem;
    gap: 10px;
  }

  .financial-tab__count {
    min-width: 30px;
    padding: 5px 9px;
    font-size: 0.74rem;
  }

  .financial-panel {
    padding: 18px 14px;
    border-radius: 18px;
  }

  .financial-panel__header {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 18px;
  }

  .financial-panel__title {
    font-size: 1.1rem;
  }

  .financial-panel__badge {
    padding: 8px 12px;
  }

  .financial-report-item {
    gap: 12px;
    padding: 14px;
    border-radius: 16px;
    align-items: flex-start;
  }

  .financial-report-item--nested {
    margin: 0 10px 10px;
  }

  .financial-report-item__icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }

  .financial-report-item__title {
    font-size: 0.92rem;
    line-height: 1.4;
  }

  .financial-report-item__meta {
    font-size: 0.78rem;
  }

  .financial-report-item__arrow {
    margin-top: 2px;
    font-size: 18px !important;
  }

  .financial-group {
    border-radius: 18px;
  }

  .financial-group__activator {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .financial-group__heading {
    font-size: 0.94rem;
  }

  .financial-group__count {
    font-size: 0.76rem;
  }

  .financial-empty-state {
    padding: 20px 14px;
    border-radius: 16px;
    font-size: 0.88rem;
  }
}
</style>
